import { StackProps } from "@chakra-ui/react";
import {
  DefaultControls,
  DynamicLegend,
  MapWrapper,
  UserLocationPin,
} from "@ui/maps/common";
import Map from "react-map-gl";
import {
  UseNRICensusLayer,
  useNRICensusLayer,
} from "./hooks/use-nri-census-layer";
import NRICensusPopup from "./nri-census-popup";
export interface NRICensusMapProps extends UseNRICensusLayer {
  mapboxAccessToken?: string;

  wrapperProps?: StackProps;
}

export function NRICensusMap({ wrapperProps, ...props }: NRICensusMapProps) {
  const {
    ref,
    onLoad,
    initialViewState,
    onClick,
    resetViewState,
    interactiveLayerIds,
    legendRows,
    popover,
    setPopover,
  } = useNRICensusLayer(props);
  return (
    <MapWrapper
      sx={{
        ".mapboxgl-popup-close-button": {
          display: "none",
        },
      }}
      position="relative"
      {...wrapperProps}
    >
      <Map
        ref={ref}
        onLoad={onLoad}
        initialViewState={initialViewState}
        onClick={onClick}
        attributionControl={false}
        interactiveLayerIds={interactiveLayerIds}
        // disable pitch
        maxPitch={0}
        // disable rotation
        dragRotate={false}
        // disable scroll zooming
        scrollZoom={false}
        mapStyle={
          "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
        }
        mapboxAccessToken={
          props?.mapboxAccessToken ||
          process.env.NEXT_PUBLIC_CLIENT_MAPBOX_ACCESS_TOKEN
        }
        style={{ height: "100%", width: "100%" }}
      >
        {popover && <NRICensusPopup {...popover} setPopover={setPopover} />}
        <DefaultControls resetViewport={resetViewState} />
        <DynamicLegend
          legendRows={legendRows}
          position="absolute"
          bottom="1"
          left="1"
        />
        <UserLocationPin
          userLocation={{
            lat: props.latitude,
            lon: props.longitude,
          }}
        />
      </Map>
    </MapWrapper>
  );
}

export default NRICensusMap;
